var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsecaseImg6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M192 0a95.9 95.9 0 0 0-90.5 64H64a64 64 0 0 0-64 64v320a64 64 0 0 0 64 64h256a64 64 0 0 0 64-64V128a64 64 0 0 0-64-64h-37.5A95.9 95.9 0 0 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-86.2 165.3a56.1 56.1 0 0 1 52.8-37.3h58.3a63.1 63.1 0 0 1 31.4 117.9L216 328.4a24 24 0 0 1-48-.4v-13.5a24 24 0 0 1 12.1-20.8l44.3-25.4a15.1 15.1 0 0 0-7.5-28.2h-58.3a7.9 7.9 0 0 0-7.5 5.3l-.4 1.2a24 24 0 0 1-45.2-16l.4-1.2zM160 416a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsecaseImg6);
export default __webpack_public_path__ + "static/media/usecaseImg6.cb831e70fa7214d326bf401a3e490e8c.svg";
export { ForwardRef as ReactComponent };